import React from 'react';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import PulseCheckLogo from '../../../../../../PulseCheck/img/tile-logo.svg';

interface Props {
  icon: 'PulseCheck' | string;
}

export const CustomIcon = ({ icon }: Props) => {
  const renderIcon = () => {
    switch (icon) {
      case 'PulseCheck':
        return <PulseCheckLogo width={24} />;
      default:
        throw new Error(`Unknown custom icon: ${icon}`);
    }
  };

  return (
    <Text color="neutral.500" css="line-height: 0">
      {renderIcon()}
    </Text>
  );
};
